//#region Components
import { useEffect, useState } from "react";
import EventAttendanceComponent from "./EventAttendanceComponent";
import { eventsSessionStorage } from "services/storage/events";
import { requestEventExists } from "services/events/aboutEvents";
import Preloader from "components/Preloader/Preloader";
import { Navigate } from "react-router-dom";
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
//#endregion

const EventAttendance = () => {
	const [eventExists, setEventExists] = useState(null);
	useEffect(() => {
		verifyIfEventExists();
	}, []);
	const verifyIfEventExists = async () => {
		const eventData = eventsSessionStorage.eventDataForAttendance.get();
		if (!eventData?.id) {
			setEventExists(false);
			return;
		}
		const eventExists = await requestEventExists(eventData.id);
		setEventExists(eventExists);
	};
	if (eventExists === null) return <Preloader hidden={false} />;
	if (!eventExists)
		return (
			<Navigate
				to={ABSOLUTE_PATHS.EVENT_LIST}
				replace
			/>
		);
	return <EventAttendanceComponent />;
};

export default EventAttendance;
